export const educationValues = {
  1: 'HIGHSCHOOL',
  2: 'COLLEGE',
  3: 'BACHELOR',
  4: 'MASTERS',
  5: 'PHD',
}

export const genderValues = {
  1: 'FEMALE',
  2: 'MALE',
  3: 'OTHERS',
}

export const nationalityValues = {
  1: 'IRAN',
  2: 'OTHERS',
}

export const domHandValues = {
  1: 'LEFT',
  2: 'RIGHT',
}

export const hearingValues = {
  1: 'HEALTHY',
  2: 'CORRECTED',
  3: 'ONE_EAR_DISABILITY',
  4: 'TWO_EARS_DISABILITY',
}

export const visualValues = {
  1: 'HEALTHY',
  2: 'CORRECTED',
  3: 'ONE_EYE_DISABILITY',
  4: 'TWO_EYES_DISABILITY',
}
